import { useStatsigClient } from '@rover/rsdk/src/modules/Statsig';

export type SearchByNameExperimentState = {
  isEnabled: boolean;
};

export function useSearchByNameExperiment(): SearchByNameExperimentState {
  const { getExperiment } = useStatsigClient();

  return { isEnabled: Boolean(getExperiment('search_by_name').get('is_enabled', false)) };
}
